/**
 * StaffPortalDutyService
 * Read-only service for staff duty-assignment operations.
 * Route: api/staff-portal/duties
 */
import { StaffPortalBaseService } from './StaffPortalBaseService';
export class StaffPortalDutyService extends StaffPortalBaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? StaffPortalDutyService.DEFAULT_SERVICE_PATH,
            basePath: config?.basePath ?? StaffPortalDutyService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get duty assignments for the current staff member.
     * GET /api/staff-portal/duties
     */
    async getMyDuties() {
        const response = await this.getMyDutiesRaw();
        return response.data ?? [];
    }
    getMyDutiesRaw() {
        return this.get();
    }
    /**
     * Get the catalogue of all duty definitions.
     * GET /api/staff-portal/duties/catalogue
     */
    async getDutyCatalogue() {
        const response = await this.getDutyCatalogueRaw();
        return response.data ?? [];
    }
    getDutyCatalogueRaw() {
        return this.get('catalogue');
    }
}
// All Staff Portal endpoints live under the HRManagement API gateway, so
// every service must route through the `hr` service path. Naming each one
// after its own resource (e.g. 'duties') was a copy-paste bug that produced
// URLs like `/duties/api/staff-portal/duties` and broke every staff page.
StaffPortalDutyService.DEFAULT_SERVICE_PATH = 'hr';
StaffPortalDutyService.BASE_PATH = 'api/staff-portal/duties';
//# sourceMappingURL=StaffPortalDutyService.js.map